<template>
    <a href="#" :title="text.delete + ' ' + linkName" @click="onClick($event)">{{text.delete}}</a>
</template>

<script>
    import {log} from "@/shared/utils";
    import lang from "@/shared/lang";

    export default {
        name: "DeleteAction",
        props: {
            linkName: {
                type: String
            },
        },
        computed: {
            text() {
                return lang;
            },
        },
        methods: {
            onClick(e) {
                e.preventDefault();

                log("Action fired");

                this.$emit('actionCalled')
            }
        },
    }
</script>